/**
 * F9 · Share — its own screen.
 *
 * Reads THE designed card (src/lib/designed-card.ts) and renders the ONE share
 * panel. Nothing is generated, collected or consented here.
 */
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSiteContent } from "@/hooks/useSiteContent";
import { S5_SECTION, S5_DEFAULTS } from "@/content/screens/s5";
import {
  Display,
  FunnelContainer,
  FunnelHeader,
  FunnelPage,
  PrimaryButton,
  StickyBar,
} from "@/components/consumer/chrome";
import { ShareCardPanel } from "@/components/consumer/ShareCardPanel";
import { readDesignedCard } from "@/lib/designed-card";
import {
  readCardCustomization,
  readStylePick,
  saveCardCustomization,
  type CardCustomization,
} from "@/lib/consumer-session";
import { findTile } from "@/lib/style-art";
import { useConsumerFlow } from "../ConsumerFlow";

export default function S5bShare() {
  const { t } = useSiteContent(S5_SECTION, S5_DEFAULTS);
  const { program } = useConsumerFlow();
  const navigate = useNavigate();

  const card = useMemo(() => readDesignedCard(program.slug), [program.slug]);
  const custom = readCardCustomization(program.slug);
  const pick = readStylePick(program.slug);
  const styleName = findTile(program.styles, pick?.style_id)?.name ?? "your card";
  

  return (
    <FunnelPage testId="s5b-share">
      <FunnelContainer size="form">
        <FunnelHeader backTo=".." backLabel={t("s5.header.back")} step={t("s5.header.step")} />

        <Display className="mb-2.5 max-w-[16ch]">{t("s5.share.title")}</Display>

        <ShareCardPanel
          card={card}
          styleName={styleName}
          styleId={pick?.style_id}
          
          t={t}
          initialFormat={custom?.format ?? "story"}
          initialCaption={custom?.caption}
          onPresentationChange={({ format, caption }) =>
            saveCardCustomization(program.slug, { ...(custom ?? {}), format, caption } as CardCustomization)
          }
        />
      </FunnelContainer>

      <StickyBar>
        <PrimaryButton onClick={() => navigate("/account")} data-testid="s5b-share-done" className="flex-1">
          {t("s8.header.accountLink")}
        </PrimaryButton>
      </StickyBar>
    </FunnelPage>
  );
}
